module.exports = "div.table {\r\n    display: table;\r\n    width: 100%;\r\n    margin-bottom: 14px;\r\n}\r\n\r\ndiv.table-cell{\r\n    display: table-cell;\r\n}\r\n\r\ndiv.table-cell:not(.space){\r\n    width: 49%;\r\n}\r\n\r\nimg.imageCenter {\r\n    position: relative;\r\n    margin: auto;\r\n}\r\n\r\ndiv.imageCenter {\r\n    height: 206px;\r\n    overflow: auto;\r\n    cursor:pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/infopublic/infopublic.component.css
// module id = ./src/app/admin/infopublic/infopublic.component.css
// module chunks = main